import React, { FC } from "react";
import styled from "styled-components";

import { primary } from "@formant/ui/component/common/Colors";

import { evaluateExpression } from "./evaluateExpression";
import { getSchema } from "./GetSchema";
import { getArrayValue } from "./JsonSchemaArrayOfObjects";
import { Label } from "./Label";
import { ListButton } from "./ListButton";
import { ListInput } from "./ListInput";
import { IInputProps, IJsonArraySchema, IJsonStringSchema } from "./types";
import { updatePath } from "./updatePath";

export const ArrayInput: FC<IInputProps<IJsonArraySchema>> = props => {
    const { params, schema, setParams, path } = props;

    const values = getArrayValue(params, path);

    if (!evaluateExpression(params, path, schema["$formant.visible.when"])) {
        return null;
    }

    return (
        <Container>
            <Label
                value={schema.title}
                description={schema.description}
                link={schema["$formant.documentationUrl"]}
            />
            <ListContainer>
                {values.map((_, newIndex) => (
                    <ListInput
                        key={["list-input", newIndex].join("/")}
                        params={props.params}
                        schema={
                            getSchema(
                                schema,
                                props.currentPath.concat(String(newIndex)),
                            ) as IJsonStringSchema
                        }
                        setParams={setParams}
                        currentPath={props.currentPath}
                        path={props.path.concat(String(newIndex))}
                        setCurrentPath={props.setCurrentPath}
                        validation={props.validation}
                    />
                ))}
                <AddListButton
                    items={values.length}
                    onClick={() => {
                        const nextArrayPath = [...path, String(values.length)];
                        setParams(prev => updatePath(prev, nextArrayPath, ""));
                    }}
                    empty={true}
                >
                    Add...
                </AddListButton>
            </ListContainer>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 1rem;
    z-index: 0;
`;

const AddListButton = styled(ListButton)<{ items: number }>`
    position: relative;
    z-index: 0;
    margin-bottom: 0rem !important;

    border-radius: ${props =>
        props.items > 0
            ? "0rem 0rem 0.1875rem 0.1875rem"
            : "0.1875rem 0.1875rem 0.1875rem 0.1875rem"};
`;

const ListContainer = styled.div`
    background-color: ${primary.steel01};
    width: 19.5rem;
    border-radius: 0.1875rem;

    p {
        display: none;
    }
`;
